import { useCallback, useContext } from "react";

import RelatedTestsSection from "@/components/reports/RelatedTestsSection";
import { getWardUrl, WARDS_ORDER_URL, WARD_TEST_URL } from "@/core/urls";
import { ViewerContext } from "@/tpo/Viewer";

import { REPORT_RELATED_TESTS_QUERY } from "../graphql/queries";

export default function WardRelatedTestsSection({ report }) {
  const { userId } = useContext(ViewerContext);

  const getOrderUrl = useCallback(
    orderId =>
      getWardUrl(WARDS_ORDER_URL, {
        patientId: userId,
        orderId
      }),
    [userId]
  );

  const getTestResultUrl = useCallback(
    userTestId =>
      getWardUrl(WARD_TEST_URL, {
        patientId: userId,
        userTestId
      }),
    [userId]
  );

  return (
    <RelatedTestsSection
      query={REPORT_RELATED_TESTS_QUERY}
      variables={{
        userId,
        report: report?.slug,
        allTests: true,
        includeUnapproved: true
      }}
      skip={!userId || !report?.slug}
      getOrderUrl={getOrderUrl}
      getTestResultUrl={getTestResultUrl}
    />
  );
}
